import Splide from '@splidejs/splide';

const selectors = {
  carousel: '[data-slideshow-carousel]',
};

export default class DynamicSlideshow {
  constructor(section) {
    this.el = section.el;
    this.data = section.data;
    this.slideCount = this.data.slideCount;
    this.section = section;
    this.carouselEl = this.el.querySelector(selectors.carousel);
    this.splide = null;

    this._init();
  }

  _init() {
    if (!this.carouselEl) {
      return;
    }

    // Only initialize Splide if there's more than one slide
    if (this.slideCount <= 1) {
      return;
    }

    this.splide = new Splide(this.carouselEl, {
      perPage: 1,
      perMove: 1,
      gap: 0,
      type: 'loop',
      autoplay: true,
      interval: 5000,
      pauseOnHover: true,
      arrows: true,
      pagination: true,
      mediaQuery: 'min',
    });

    this.splide.mount();
  }

  onSectionUnload() {
    if (this.splide) {
      this.splide.destroy();
      this.splide = null;
    }
  }
}
